export const CHARACTER_GLB_URL = '/models/kendoOutfit.glb';
export const CHARACTER_ANIM_FILES = [
    'Dying.fbx',
    'Arm Stretching.fbx',
    'Great Sword Casting.fbx',
    'Great Sword Crouching.fbx',
    'Great Sword Crouching (1).fbx',
    'Clapping.fbx',
    'Great Sword Idle.fbx',
    'Jog In Circle.fbx',
    'Spin In Place.fbx',
];
export const PAIR_SPAWN_COUNT = 3;
export const CHARACTER_SPAWN_COUNT = PAIR_SPAWN_COUNT * 2;
export const GROUND_Y     = -0.15;
export const SPAWN_HEIGHT = 0;

export const FLOOR_CONFIG = {
    y:         GROUND_Y,
    sizeX:     10,
    sizeZ:     10,
    centerX:  -0.8,
    centerZ:  -0.05,
    color:     0x00ff88,
    opacity:   0.25,
    showDebug: true,
};

export const SHOW_RAGDOLL_DEBUG = true;
export const RAGDOLL_JOINTS = [
    { bone: 'mixamorigHips',         r: 0.024 },
    { bone: 'mixamorigSpine1',       r: 0.020 },
    { bone: 'mixamorigSpine2',       r: 0.018 },
    { bone: 'mixamorigHead',         r: 0.022 },
    { bone: 'mixamorigLeftShoulder', r: 0.012 },
    { bone: 'mixamorigLeftArm',      r: 0.014 },
    { bone: 'mixamorigLeftForeArm',  r: 0.012 },
    { bone: 'mixamorigRightShoulder',r: 0.012 },
    { bone: 'mixamorigRightArm',     r: 0.014 },
    { bone: 'mixamorigRightForeArm', r: 0.012 },
    { bone: 'mixamorigLeftUpLeg',    r: 0.018 },
    { bone: 'mixamorigLeftLeg',      r: 0.014 },
    { bone: 'mixamorigRightUpLeg',   r: 0.018 },
    { bone: 'mixamorigRightLeg',     r: 0.014 },
];

export const DOJO_SPZ_URL     = '/splats/Dojo.spz';
export const DOJO_SPZ_LOW_URL = '/splats/Dojo-low.spz';

export const DEFAULT_DOJO_CAMERA = {
    position: {
        x: 0.558293227,
        y: 0.051429819577,
        z: 0.01173007055315846,
    },
    target: {
        x: -1.836098804355067,
        y: -0.45458290968975434,
        z: -0.11320829177291929,
    },
    quaternion: {
        x: -0.022885426301679532,
        y: 0.7348964912337881,
        z: 0.02483016993132845,
        w: 0.6773380744476415,
    },
    pivotDistance: 1.8,
};

export const QUALITY_PRESETS = {
    ultra: {
        renderScale: 1,
        pixelRatioCap: 1.25,
        sparkUpdateIntervalMs: 16,
        minSortIntervalMs: 30,
        maxPixelRadius: 256,
        clipXY: 1.35,
    },
    high: {
        renderScale: 0.92,
        pixelRatioCap: 1,
        sparkUpdateIntervalMs: 40,
        minSortIntervalMs: 60,
        maxPixelRadius: 224,
        clipXY: 1.3,
    },
    medium: {
        renderScale: 0.82,
        pixelRatioCap: 1,
        sparkUpdateIntervalMs: 80,
        minSortIntervalMs: 120,
        maxPixelRadius: 192,
        clipXY: 1.2,
    },
    low: {
        renderScale: 0.72,
        pixelRatioCap: 1,
        sparkUpdateIntervalMs: 120,
        minSortIntervalMs: 180,
        maxPixelRadius: 160,
        clipXY: 1.12,
    },
    potato: {
        renderScale: 0.6,
        pixelRatioCap: 1,
        sparkUpdateIntervalMs: 180,
        minSortIntervalMs: 260,
        maxPixelRadius: 136,
        clipXY: 1.05,
    },
};
export const QUALITY_ORDER = ['ultra', 'high', 'medium', 'low', 'potato'];

// Ragdoll constraint pairs: [parentIndex, childIndex] into RAGDOLL_JOINTS array
export const RAGDOLL_CONSTRAINTS = [
    [0, 1],   // Hips → Spine1
    [1, 2],   // Spine1 → Spine2
    [2, 3],   // Spine2 → Head
    [2, 4],   // Spine2 → LeftShoulder
    [4, 5],   // LeftShoulder → LeftArm
    [5, 6],   // LeftArm → LeftForeArm
    [2, 7],   // Spine2 → RightShoulder
    [7, 8],   // RightShoulder → RightArm
    [8, 9],   // RightArm → RightForeArm
    [0, 10],  // Hips → LeftUpLeg
    [10, 11], // LeftUpLeg → LeftLeg
    [0, 12],  // Hips → RightUpLeg
    [12, 13], // RightUpLeg → RightLeg
];

export const RAGDOLL_JOINT_MASS = 0.5; // kg per joint body
